// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QUFY","comment":"styles_comment__3Ljm0"};